export default "__VITE_ASSET__BqgXNyWr__"